import React from 'react'
import { ButtonBase, Grid, withStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import tree_of_burdens from 'media/tree_of_burdens/tree_of_burdens_buckeye.png'
import SVGInline from 'react-svg-inline/src'
import activityBlack from 'media/article_list/activity_black_notext.svg'
import scrollBlack from 'media/article_list/scroll_black.svg'
import arrowBlack from 'media/article_list/arrow_black.svg'
import ContentDrawer from '../ContentDrawer'
import BurdenTreeSegment from './BurdenTreeSegment'

const styles = theme => ({
  rightSide: {
    width: '45%',
    backgroundColor: '#e4e4e4',
    height: '100%',
    padding: 25,

  },
  leftSide: {
    width: '54%',
    padding: 25,
    textAlign: 'center',
  },
  articleTitle: {
    fontWeight: 'bold',
    lineHeight: 1.69,
    fontSize: 29,
    textTransform: 'uppercase',
    marginTop: 10,
    textAlign: 'center'
  },
  articleTitleBorder: {
    backgroundColor: 'black',
    height: 5,
    width: 150,
    margin: '30px 0px'
  }
  , burdenTree: {
    textTransform: 'uppercase',
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center',
    fontSize: 22,
    padding: 15,
    margin: '30px 0px'
  },
  imgClass: {
    width: ' 60%',
    margin: '60px auto'
  },
  helpIcon: {
    display: 'inline-flex',
    color: 'black',
    margin: 10,
  },
  rightTextInner: {
    display: 'inline-flex',
    textTransform: 'uppercase',
    padding: 10,
    fontSize: 21,
    fontWeight: 'bold',
    color: 'white'
  },
  rightTextInnerButton: {
    display: 'inline-flex',
    textTransform: 'uppercase',
    padding: 10,
    fontSize: 31,
    fontWeight: 'bold',
  },
  rightText: {
    color: 'black',
    margin: 20,
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'left',
    alignItems: 'center'
  },
  activityText: {
    backgroundColor: 'black',
    color: 'white',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 20,
    display: 'flex'

  },
  goalOfTheTool: {
    backgroundColor: 'black',
    color: '#fff7f7',
    fontSize: 20,
    margin: '20px auto',
    padding: 20,
    width: '60%',
    textAlign: 'center',
    textDecoration: 'underline'
  },
  addStory: {
    color: '#fff7f7',
    lineHeight: 1.94,
    margin: '20px auto',
    fontSize: 20,
    backgroundColor: '#a20202',
    padding: '20px 60px',
    textAlign: 'center',
    textDecoration: 'underline'
  },
  drawerContainer: {
    width: '70%'
  },
  descriptionText: {
    fontSize: 18,
    textAlign: 'center',
  },
  arrowSide: {
    position: 'fixed',
    left: '70%',
    top: '50%',
    transform: 'translate(-55px)',
    zIndex: 1400,
    backgroundColor: 'white',
    borderRadius: 90
  },
  scrollIcon: {
    position: 'absolute',
    right: 60,
    top: 20
  },
})

class BurdenTreeSummary extends React.Component {
  state = {
    drawerOpen: false
  }

  openDrawer () {
    this.setState({ drawerOpen: true })
  }

  closeDrawer () {
    this.setState({ drawerOpen: false })
  }

  render () {
    let {
      classes,
      child,
    } = this.props
    return <Grid container>
      <Grid item className={classes.leftSide}>
        <Typography className={classes.burdenTree}>
          collective tree of burdens
        </Typography>
        <img src={tree_of_burdens} alt="tree of burdens" className={classes.imgClass}/>
      </Grid>
      <Grid item className={classes.rightSide}>
        <Typography className={classes.burdenTree}>
          introduction
        </Typography>
        <div className={classes.articleTitle}>
          Discharging burdens, finding potentials through collective sharing
          <div className={classes.articleTitleBorder}></div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: child.formatted_content }}>
        </div>
        <div className={classes.rightText}>
          <ButtonBase onClick={() => this.openDrawer()}>
            <SVGInline svg={activityBlack} className={classes.helpIcon} height='37px' width='37px' fill={'#000'}/>
            <Typography className={classes.rightTextInnerButton}>
              Activity
            </Typography>
          </ButtonBase>
        </div>

      </Grid>
      {this.state.drawerOpen ?

        <div className={classes.arrowSide} onClick={() => this.closeDrawer()}>
          <SVGInline svg={arrowBlack} className={classes.helpIcon} height='90px' width='90px' fill={'#fff'}/>
        </div> : ''}
      <ContentDrawer open={this.state.drawerOpen} onClose={() => this.closeDrawer()}>
        <div className={classes.scrollIcon}>
          <SVGInline svg={scrollBlack} className={classes.helpIcon} height='70px' width='70px' fill={'#fff'}/>
        </div>
        <div className={classes.activityText}>
          <SVGInline svg={activityBlack} className={classes.helpIcon} height='31px' width='31px' fill={'#fff'}/>
          <Typography className={classes.rightTextInner}>
            Activity
          </Typography>
        </div>
        <div className={classes.articleTitle}>
          Collective family tree of burdens and potentials
        </div>
        <div className={classes.articleTitleBorder}>
          &nbsp;
        </div>
        <div className={classes.descriptionText}>
          Collective family tree of burdens and potentials - model builds on idea of transmitted burdens,
          (taakkasiirtymä) a concept created by Finnish psychoanalytic Martti Siirala. Experienced but silenced
          burdens and traumatic events carried by families, communities or nations consciously or unconsciously are
          transmitted through generations unless collectively shared and healed. Personal life events, losses, wars,
          changes, economical challenges, religious upheavals, oppressions, natural disasters, political struggles can
          be stored unsolved in us and affect our everyday life. Central idea of healing transmitted traumas is their
          collective sharing.
          <br/>
          <br/>
          With this tool we create visual collective representation of burdens the potentials that affect and
          encourage us to learn from each other. Tool contributes to the meaning and value of collectives and
          collective sharing.
        </div>
        <div className={classes.goalOfTheTool}>
          The goal of the tool is to collectively reflect and share our own experiences and observations on how we as
          individuals have experienced, learned and drawn from the potentials we have inherited from others.
        </div>
        <div className={classes.addStory}>
          <div>
            1. ADD YOUR STORY
          </div>
          <div>
            2. EXPLORE STORIES OF OTHER USERS
          </div>
        </div>
        <BurdenTreeSegment/>
        {/*TODO add comments */}
      </ContentDrawer>
    </Grid>
  }

}

export default withStyles(styles)(BurdenTreeSummary)
